import {useContext, useEffect, useState} from 'react'
import {KTIcon} from '../../../../../_metronic/helpers'
import {SheetContext, SheetEditContext} from '../SheetContexts'

const SectionEditModalHeader = () => {
  const {closeSectionModal, sectionData} = useContext(SheetEditContext)
  const [title, setTitle] = useState('')

  useEffect(() => {
    setTitle('Nueva')
    if (sectionData.id.length > 0) setTitle('Editar')
  }, [])

  return (
    <div className='modal-header'>
      {/* begin::Modal title */}
      <h2 className='fw-bolder'>{title} Sección</h2>
      {/* end::Modal title */}

      {/* begin::Close */}
      <div
        className='btn btn-icon btn-sm btn-active-icon-primary'
        onClick={() => closeSectionModal()}
        style={{cursor: 'pointer'}}
      >
        <KTIcon iconName='cross' className='fs-1' />
      </div>
      {/* end::Close */}
    </div>
  )
}

export {SectionEditModalHeader}
